import defineComponent from 'flight';
import AbstractModal from 'static/script/utils/abstract-modal';
import SearchResultFilterBoxUI from 'static/script/app/ui/search-result/search-result-filter-box-ui';
import FormSelectUI from 'static/script/app/ui/form-select-ui';
import ResultLayoutTogglerUI from 'static/script/app/ui/search-result/result-layout-toggler-ui';
import ShowAllFiltersUI from 'static/script/app/ui/search-result/show-all-filters-ui';
import JST from 'static/script/templates/templates';
import breakpoints from 'static/script/utils/breakpoints';
import priceSlider from 'containers/price-slider';

// This Component extends AbstractModal
function ModalFilterUI() {
    let $opener,
        menuSelector,
        openerParams;

    this.defaultAttrs({
        filterLink: '.modal .mobile-filter-menu a[data-nav]',
        disabledClass: 'search-filters-list-item-empty-tag',
        navigateEvent: 'ui:modal-filter-ui:on-load',
        layoutClasses: ['layout-list', 'layout-grid'],
        mobileFilterMenuClass: '.mobile-filter-menu',
        allCategoriesSelector: '[data-all-categories]'
    });

    this._triggerOpen = function (evt, payload) {
        let evtData = {};
        this._disableAds();
        $opener = $(payload.target);
        menuSelector = payload.menuSelector;
        openerParams = payload;
        evtData.content = this._getModalContent();
        evtData.cssClass = 'modal-filter ' + 'modal-filter-' + payload.name;
        evtData.content.find('[data-expandable]').removeAttr('data-expandable');

        this.openModal(evtData);
        this._attachComponents(true);
        this._setCurrentResultLayout(this._getCurrentResultLayout());
        this._updateClearAllFiltersUrl();
        this._setHeadline();
        this._updateAllCategoriesLink();
        this._addListeners();
        this._addGaTracking();
    };

    this._addGaTracking = function () {
        if (openerParams.name) {
            this.trigger('analytics:track-event', {
                category: 'Search Filters',
                action: 'Open filter modal',
                label: openerParams.name
            });
        }
    };


    // TODO: This should be done via backend
    this._updateAllCategoriesLink = function () {
        if (openerParams.name === 'subdepartment') {
            let queryString = (window.location.search[0] === '?') ? window.location.search.substring(1) : window.location.search;

            let params = queryString.split('&');
            let paramsToRemove = ['subDepartments', 'shoeTypes', 'shoeSizes', 'brandTags', 'categoryId']; // The "tag"-parameters + categoryId
            let p;

            let isSearch = _.find(params, function (param) {
                p = param.split('=');
                if (p[0] === 'q' && p[1].length > 0) {
                    return true;
                }
                return false;
            });

            if (!!queryString && !!isSearch) {
                let keepTheseParams = params.filter(function (param) {
                    p = param.split('=');
                    if (paramsToRemove.indexOf(p[0]) > -1) {
                        return false;
                    }
                    return true;
                });
                let url = '/search?' + keepTheseParams.join('&');
                this.$modalHtml.find(this.attr.allCategoriesSelector).attr('href', url);
            }
        }
    };

    this._setHeadline = function () {
        if (openerParams.modalHeader) {
            this.$modalHtml.find('[data-filter-menu-headline]').text(openerParams.modalHeader);
        }
    };

    this._getCurrentResultLayout = function () {
        let validClasses = this.attr.layoutClasses;
        let currentLayoutClasses = $('[data-result-layout]')[0].className.split(' ');

        for (let i = 0; i < currentLayoutClasses.length; i++) {
            if (validClasses.indexOf(currentLayoutClasses[i]) > -1) {
                return currentLayoutClasses[i];
            }
        }

        return undefined;
    };

    this._updateClearAllFiltersUrl = function () {
        if (openerParams.name === 'filters') {

            let nrOfAppliedFilters = parseInt($opener.find('[data-active-filters]').data('active-filters'), 10);
            if (nrOfAppliedFilters > 0) {
                this.$modal.find('[data-clear-all-filters]').attr('href', this._stripUrlParameters()).removeClass('hidden');
            } else {
                this.$modal.find('[data-clear-all-filters]').addClass('hidden');
            }
        }
    };

    this._stripUrlParameters = function (dontRemoveUs) {
        let query = window.location.search.substring(1),
            queryVars = query.split('&'),
            pair,
            keepTheseParams = [],
            keptQueryString = '';

        dontRemoveUs = dontRemoveUs || ['q', 'categoryId', 'sortBy', 'subDepartments'];

        queryVars.forEach(function (queryVar) {
            pair = queryVar.split('=');
            if (dontRemoveUs.indexOf(pair[0]) > -1) {
                keepTheseParams.push(pair[0] + '=' + pair[1]);
            }
        });

        if (keepTheseParams) {
            keptQueryString = keepTheseParams.join('&');
        }

        return (keptQueryString.length > 0) ? window.location.pathname + '?' + keptQueryString : window.location.pathname;
    };

    this._setCurrentResultLayout = function (currentLayoutCssClass) {
        let validClasses = this.attr.layoutClasses;
        this.$modal.removeClass(validClasses.join(' '))
            .addClass(currentLayoutCssClass);
    };

    this._attachComponents = function (initial) {
        if (initial === true) {
            ResultLayoutTogglerUI.attachTo(this.$modal.find('[data-search-result-toggler]'));
        }

        ShowAllFiltersUI.attachTo(this.$modal.find('[data-search-tags-box]'));
        FormSelectUI.attachTo(this.$modal.find('[data-form-select]'), { navigateEvent: this.attr.navigateEvent });
        SearchResultFilterBoxUI.attachTo(this.$modal.find('[data-search-filter-box]'));

        priceSlider(this.$modal[0].querySelectorAll('[data-price-range]'), {
            navigateEvent: this.attr.navigateEvent
        });
    };

    this._formatFilters = function (filters) {
        let $i;

        if (filters.hasClass('tag-navigation-filter-subdepartments')) {
            filters.addClass('search-filters-section-open');
        }

        filters.find('.search-filter-list-current-value').each(function (index, item) {
            $i = $(item);
            $i.parent().append($i);
            if (!$i.hasClass('search-filter-list-current-default-value')) {
                $i.parent().addClass('not-default');
            }
        });

        filters.height('auto'); // Fix this
        return filters;
    };

    this._getModalContent = function () {
        let filters = $(menuSelector).clone(),
            clearFilterUrl = $('[data-search-result-clear-filter-url]').data('search-result-clear-filter-url'),
            filterContainer = $(JST['templates/mobile-filter-menu.html']({clearFilterUrl: clearFilterUrl}));

        filters = this._formatFilters(filters);

        filterContainer.find('.filter-menu-wrapper:eq(0)').append(filters);
        return filterContainer;
    };


    this._adjustModalPosition = function () {
        let filterButton = $opener;

        this.$modal.css('top', this._getModalTop());
        this.$modal.css(this._getModalLeft());

        this._scrollToButton();

        let menuLeftOffset = this.$modal.find(this.attr.mobileFilterMenuClass).offset().left;

        let arrowPosition = parseInt(filterButton.offset().left + (filterButton.width() / 2 - menuLeftOffset), 10);

        if (parseInt(arrowPosition, 10) < 30) {
            arrowPosition = '30px';
        }

        this.$modal.find('.filter-menu-belong-to-arrow').css('left', arrowPosition);
    };

    this._getModalTop = function () {
        let topPosition = parseInt($opener.offset().top + $opener.height() + 10, 10);
        return topPosition;
    };

    this._getModalLeft = function () {
        let vieportWidth = $(window).width(),
            hValues = {},
            openerCenter = $opener.offset().left + (parseInt($opener.width() / 2, 10)),
            maxLeft = parseInt(vieportWidth - this.$modal.width(), 10) - 10,
            left = openerCenter - parseInt(this.$modal.width() / 2, 10);

        if (!breakpoints.isVisible(breakpoints.large)) {
            hValues.left = maxLeft + 'px';
        } else {
            if (left < 10) {
                left = 10;
            } else if (left > maxLeft) {
                left = maxLeft;
            }

            hValues.left = left + 'px';
        }

        return hValues;
    };

    this._scrollToButton = function () {
        let filterButton = $opener,
            buttonOffset = filterButton.offset();

        this.buttonOffsetTop = (parseInt(buttonOffset.top, 10) - 10);

        window.scrollTo(0, this.buttonOffsetTop);
    };

    this._removeModal = function () {
        if (this.$modalHtml) {
            this.$modalHtml.remove();
        }
    };

    this._refreshModalContent = function () {
        let content = this._getModalContent(),
            modalBoxes = this.$modal.find('[data-search-filter-box]'),
            currentOpened = modalBoxes.filter(function (index, box) {
                let $box = $(box);
                return ($box.hasClass('search-filters-section-open') && $box.hasClass('tag-navigation-filter'));
            });

        let i,
            co,
            type;

        for (i = 0; i < currentOpened.length; i++) {
            co = currentOpened.eq(0);
            type = co.data('search-filter-box');
            content.find('[data-search-filter-box="' + type + '"]').addClass('search-filters-section-open');
        }

        this.$modal.find(this.attr.mobileFilterMenuClass).replaceWith(content);
        this._attachComponents();
        this.trigger('ui:modal-filter-ui:on-content-refresh', {parentNode: this.$node});
    };

    this._close = function () {
        if (!this._isActive()) {
            return;
        }
        this.off(document, 'keyup', this._escButtonClose);
        this.trigger(document, 'ui:body-container:on-modal-close');

        this._removeListeners();
        this._enableAds();
        this._scrollToButton();

        this.$modalHtml.css('opacity', 0);
        this._toggleLoading(false);
        setTimeout(function () {
            this._removeModal();
        }.bind(this), 250);
    };

    this._filterClick = function (evt) {
        evt.preventDefault();
        let $currentTarget = $(evt.currentTarget);
        let href = $currentTarget.attr('href');

        if ($currentTarget.hasClass(this.attr.disabledClass)) {
            this._toggleLoading(false);
            return;
        }

        this._lastTarget = $currentTarget;

        this.trigger(document, this.attr.navigateEvent, {href: href});
        this._toggleLoading(true);
    };

    this._toggleLoading = function (status) {
        // this.$modalHtml.toggleClass('modal-loading', !!status);
        $('body').toggleClass('modal-loading', !!status);
    };

    this._afterFilterLoad = function () {
        if (openerParams.name === 'sort' || $(openerParams.targetSelector).length === 0) {
            this._close();
            return;
        }

        this._addFilterLoaded();
        this._updateOpener($(openerParams.targetSelector));
        this._refreshModalContent();
        this._adjustModalPosition();
        this._updateClearAllFiltersUrl();
        this._updateNrOfItems();
        this._setHeadline();
        this._updateAllCategoriesLink();
        this._toggleLoading(false);
    };


    this._updateNrOfItems = function () {
        let nrOfItems = parseInt($('[data-result-total-items]').attr('data-result-total-items'), 10);

        let preText = 'Visa <br>';
        let postText = (nrOfItems === 1) ? ' träff' : ' träffar';

        let hitsText = '<span class="filter-menu-done-nr-of-hits" data-modal-close>' + nrOfItems + postText + '</span>';

        let caption = preText + hitsText;

        this.$modal.find('[data-filter-menu-done]').html(caption);
    };

    this._addFilterLoaded = function () {
        this.$modal.addClass('modal-filter-loaded');
    };

    this._updateOpener = function (newOpener) {
        $opener = newOpener;
    };

    this._onLayoutChange = function (evt, payload) {
        this._setCurrentResultLayout(payload.targetLayout);
    };

    this._disableAds = function () {
        $('body').addClass('modal-filter-active');
    };

    this._enableAds = function () {
        $('body').removeClass('modal-filter-active');
    };

    this._closeClick = function (evt) {
        if (!this._isActive()) {
            return;
        }
        if (this._closePrevented) {
            return;
        }

        let target = $(evt.target);
        if (target.attr('data-modal-close') === undefined) {
            return;
        }
        evt.stopPropagation();
        this._close();
    };

    this._addListeners = function () {
        this.on(document, 'ui:gpt:slot-loaded', this._adjustModalPosition);
        this.on(document, 'ui:search:on-layout-change', this._onLayoutChange);
        this.on(document, 'utils:window-resize:resized', this._onResize);
        this.on(document, 'data:navigation-filter:after-load', this._afterFilterLoad);
        this.on(document, 'ui:modal-filter-ui:on-modal-close', this._afterFilterLoad);

    };

    this._removeListeners = function () {
        this.off(document, 'ui:gpt:slot-loaded', this._adjustModalPosition);
        this.off(document, 'ui:search:on-layout-change', this._onLayoutChange);
        this.off(document, 'utils:window-resize:resized', this._onResize);
        this.off(document, 'data:navigation-filter:after-load', this._afterFilterLoad);
        this.off(document, 'ui:modal-filter-ui:on-modal-close', this._afterFilterLoad);
    };

    this._onResize = function () {
        if (breakpoints.isVisible(breakpoints.sidebarsearch)) {
            this._close();
        } else {
            this._adjustModalPosition();
        }
    };

    this.after('initialize', function () {
        this.on(document, 'ui:search-result:on-open-filter-click', this._triggerOpen);
        this.on(document, 'ui:teardown', this._removeListeners);

        this.on('click', {
            filterLink: this._filterClick
        });
    });
}

module.exports = AbstractModal.mixin(ModalFilterUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/modal-filter-ui.js